import * as React from "react";
import { useTranslation } from "./i18n";
var challengerColor = "#5bc0de";
var landlordColor = "#d9534f";
var clampPct = function (proportion) {
    return Math.max(0, Math.min(1, proportion)) * 100;
};
/*
 * Scoring progress bar (dark-mode friendly).
 *
 * A single horizontal track shows how many points the attacking ("challenger")
 * team has collected. Threshold markers (the level-up checkpoints) are laid out
 * as short ticks with their value labelled BELOW the track, so nothing overlaps
 * and the scale stays legible. When landlord points are visible, a second
 * marker shows their progress from the top end.
 */
var ProgressBar = function (props) {
    var t = useTranslation().t;
    var totalPoints = props.totalPoints, challengerPoints = props.challengerPoints, landlordPoints = props.landlordPoints, checkpoints = props.checkpoints;
    var challengerPct = clampPct(challengerPoints / totalPoints);
    // Landlord points count down from the top of the scale.
    var landlordMarker = totalPoints - landlordPoints;
    var landlordPct = clampPct(landlordMarker / totalPoints);
    // The challenger (blue) is the attacking side; the landlord (red) is the
    // declarer's side. Label each swatch so the local player tells at a glance
    // which color is theirs. Falls back to the neutral side names for spectators.
    var challengerLabel = props.selfOnLandlordTeam === undefined
        ? t("team.legend.opponents")
        : props.selfOnLandlordTeam
            ? t("points.opponents")
            : t("points.yourTeam");
    var landlordLabel = props.selfOnLandlordTeam === undefined
        ? t("team.legend.declarerSide")
        : props.selfOnLandlordTeam
            ? t("points.yourTeam")
            : t("points.opponents");
    return (React.createElement("div", { className: "sj-score-bar" },
        React.createElement("div", { className: "sj-score-track", "aria-hidden": "true" },
            React.createElement("div", { className: "sj-score-fill", style: {
                    width: "".concat(challengerPct, "%"),
                    backgroundColor: challengerColor,
                } }),
            checkpoints.map(function (checkpoint, i) {
                var reached = challengerPoints >= checkpoint;
                return (React.createElement("span", { key: i, className: "sj-score-tick", style: {
                        left: "".concat(clampPct(checkpoint / totalPoints), "%"),
                        backgroundColor: reached ? challengerColor : undefined,
                    } }));
            }),
            React.createElement("span", { className: "sj-score-marker", style: {
                    left: "".concat(challengerPct, "%"),
                    borderColor: challengerColor,
                } }),
            !props.hideLandlordPoints && (React.createElement("span", { className: "sj-score-marker", style: { left: "".concat(landlordPct, "%"), borderColor: landlordColor } }))),
        React.createElement("div", { className: "sj-score-scale", "aria-hidden": "true" },
            React.createElement("span", { className: "sj-score-scale-end", style: { left: "0%" } }, "0"),
            checkpoints.map(function (checkpoint, i) { return (React.createElement("span", { key: i, className: "sj-score-scale-label", style: { left: "".concat(clampPct(checkpoint / totalPoints), "%") } }, checkpoint)); }),
            React.createElement("span", { className: "sj-score-scale-end", style: { left: "100%" } }, totalPoints)),
        React.createElement("div", { className: "sj-score-legend" },
            React.createElement("span", { className: "sj-score-legend-item" },
                React.createElement("span", { className: "sj-score-swatch", style: { backgroundColor: challengerColor } }),
                React.createElement("span", null,
                    challengerLabel,
                    ": ",
                    challengerPoints,
                    t("term.fenUnit"))),
            !props.hideLandlordPoints && (React.createElement("span", { className: "sj-score-legend-item" },
                React.createElement("span", { className: "sj-score-swatch", style: { backgroundColor: landlordColor } }),
                React.createElement("span", null,
                    landlordLabel,
                    ": ",
                    landlordMarker,
                    t("term.fenUnit")))))));
};
export default ProgressBar;
